global.IS_DEBUG_ENVIRONMENT = true;
global.IS_TEST_SERVER = false;
